export const MODE_ICON = { sale: 'tag', free: 'gift', swap: 'swap', barter: 'handshake' } as const
